"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _getVideoOutputName = _interopRequireDefault(require("@devsta/get-video-output-name"));

var _classnames = _interopRequireDefault(require("classnames"));

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _lodash2 = _interopRequireDefault(require("lodash.maxby"));

var _lodash3 = _interopRequireDefault(require("lodash.uniq"));

var _queryString = _interopRequireDefault(require("query-string"));

var _sweetalert = _interopRequireDefault(require("sweetalert2"));

var _Header = _interopRequireDefault(require("./Header"));

var _ProgressBar = _interopRequireDefault(require("./ProgressBar"));

var _Drawer = _interopRequireDefault(require("./Drawer"));

var _VideoOutput = _interopRequireDefault(require("./VideoOutput"));

var _basePath = _interopRequireDefault(require("../../../common/constants/basePath"));

var _Footer = _interopRequireDefault(require("./Footer"));

var _VideoReviewContext = _interopRequireDefault(require("../contexts/VideoReviewContext"));

var _videoReviewContext = _interopRequireDefault(require("../selectors/videoReviewContext"));

var _ModalSwitcher = _interopRequireDefault(require("./ModalSwitcher"));

var _modalNames = _interopRequireDefault(require("../constants/modalNames"));

var _successAlerts = _interopRequireWildcard(require("../constants/successAlerts"));

var _buildOrgStatuses = _interopRequireDefault(require("../utils/buildOrgStatuses"));

var _buildSmartProgressData = _interopRequireDefault(require("../utils/buildSmartProgressData"));

var _formatStatuses = _interopRequireDefault(require("../utils/formatStatuses"));

require("../styles/_video-review-root.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var C_KEYCODE = 67;

var VideoReviewRoot = /*#__PURE__*/function (_Component) {
  _inherits(VideoReviewRoot, _Component);

  var _super = _createSuper(VideoReviewRoot);

  function VideoReviewRoot(props) {
    var _this;

    _classCallCheck(this, VideoReviewRoot);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "openModal", (0, _lodash.default)(function (openedModal) {
      return function () {
        _this.setState({
          openedModal: openedModal
        });
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (_ref) {
      var keyCode = _ref.keyCode;
      var orgPermissions = _this.props.orgPermissions;
      var openedModal = _this.state.openedModal;

      if (keyCode !== C_KEYCODE || !(0, _commonReact.hasPermission)('INTERNAL', orgPermissions) || document.querySelector('.comment-popover') || openedModal) {
        return;
      }

      _this.toggleInternalMode();
    });

    _defineProperty(_assertThisInitialized(_this), "closeModal", function () {
      _this.setState({
        openedModal: void 0
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleInternalMode", function () {
      _this.setState(function (_ref2) {
        var internalMode = _ref2.internalMode;
        return {
          internalMode: !internalMode
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "replaceHistorySearch", function () {
      var history = _this.props.history;
      history.replace("".concat(history.location.pathname).concat(history.location.hash));
    });

    _defineProperty(_assertThisInitialized(_this), "showAlert", function (type) {
      _sweetalert.default.fire({
        title: _successAlerts.default[type],
        customClass: {
          popup: 'video-review-root__swal',
          title: 'video-review-root__swal__title',
          confirmButton: 'video-review-root__swal__button'
        },
        buttonsStyling: false
      }).then(_this.replaceHistorySearch);
    });

    _defineProperty(_assertThisInitialized(_this), "isVideoReady", function (_ref3) {
      var assetId = _ref3.assetId,
          statusName = _ref3.status.name;
      var orgPermissions = _this.props.orgPermissions;
      var internalMode = _this.state.internalMode;

      if (!assetId) {
        return false;
      }

      return statusName !== 'EDITING' && statusName !== 'INTERNAL_REVIEW' && statusName !== 'PENDING_MASTER' || statusName === 'INTERNAL_REVIEW' && (0, _commonReact.hasPermission)('INTERNAL', orgPermissions) || internalMode;
    });

    _defineProperty(_assertThisInitialized(_this), "onApproveVersion", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props, approveOutput, history, videoId, _yield$approveOutput, data, error, currentOutput, status;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, approveOutput = _this$props.approveOutput, history = _this$props.history, videoId = _this$props.videoId;
              _context.next = 3;
              return approveOutput();

            case 3:
              _yield$approveOutput = _context.sent;
              data = _yield$approveOutput.data;
              error = _yield$approveOutput.error;

              if (!(!data || error)) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return");

            case 8:
              _this.setState({
                internalMode: false
              });

              currentOutput = _this.getCurrentOutput();
              status = data.approveVideoOutput.status;

              _this.setState({
                internalMode: false,
                approvedStatus: status
              });

              if (!(!currentOutput || status.name !== 'EDITING')) {
                _context.next = 14;
                break;
              }

              return _context.abrupt("return", void _this.fetchData());

            case 14:
              history.push("".concat(videoId, "/").concat(currentOutput.outputId, "#").concat(currentOutput.latestVersion + 1));

              _this.fetchData();

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "onRequestApproval", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _this$props2, requestApproval, history, _yield$requestApprova, data, error;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$props2 = _this.props, requestApproval = _this$props2.requestApproval, history = _this$props2.history;
              _context2.next = 3;
              return requestApproval();

            case 3:
              _yield$requestApprova = _context2.sent;
              data = _yield$requestApprova.data;
              error = _yield$requestApprova.error;

              if (!(!data || error)) {
                _context2.next = 8;
                break;
              }

              return _context2.abrupt("return", {
                error: error
              });

            case 8:
              history.replace("".concat(history.location.pathname, "?success=").concat(_successAlerts.SUCCESS_TYPE.APPROVAL_REQUESTED).concat(history.location.hash));
              return _context2.abrupt("return", {});

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty(_assertThisInitialized(_this), "formatAddons", function (requestedAddons) {
      return Object.entries(requestedAddons).reduce(function (newAddons, _ref6) {
        var _ref7 = _slicedToArray(_ref6, 2),
            key = _ref7[0],
            addonObject = _ref7[1];

        if (!addonObject || key === '__typename') {
          return newAddons;
        }

        if (key === 'SRT_CAPTIONS' && Array.isArray(addonObject)) {
          // $FlowFixMe - Flow is being silly
          var languages = addonObject.filter(function (srt) {
            return srt.value;
          }).map(function (_ref8) {
            var value = _ref8.value,
                cost = _ref8.cost;
            return {
              value: value,
              cost: cost
            };
          });
          return _objectSpread({}, newAddons, _defineProperty({}, key, (0, _lodash3.default)(languages)));
        }

        if (addonObject.value === void 0 || addonObject.value === null) {
          return newAddons;
        }

        return _objectSpread({}, newAddons, _defineProperty({}, key, {
          value: addonObject.value,
          cost: addonObject.cost
        }));
      }, {});
    });

    _defineProperty(_assertThisInitialized(_this), "onUpdateRequestedAddons", /*#__PURE__*/function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref9) {
        var versionId, requestedAddons, updateRequestedAddons, outputs, currentOutput, formattedAddons, _yield$updateRequeste, data, error, newRequestedAddons, versionIndex, newOutput, updatedVersion, index, updatedOutputs;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                versionId = _ref9.versionId, requestedAddons = _ref9.requestedAddons;
                updateRequestedAddons = _this.props.updateRequestedAddons;
                outputs = _this.state.outputs;
                currentOutput = _this.getCurrentOutput();

                if (currentOutput) {
                  _context3.next = 6;
                  break;
                }

                return _context3.abrupt("return");

              case 6:
                formattedAddons = _this.formatAddons(requestedAddons);
                _context3.next = 9;
                return updateRequestedAddons({
                  versionId: versionId,
                  requestedAddons: formattedAddons
                });

              case 9:
                _yield$updateRequeste = _context3.sent;
                data = _yield$updateRequeste.data;
                error = _yield$updateRequeste.error;

                if (!(!data || error)) {
                  _context3.next = 14;
                  break;
                }

                return _context3.abrupt("return");

              case 14:
                newRequestedAddons = data.updateRequestedAddons.requestedAddons;
                versionIndex = currentOutput.versions.findIndex(function (version) {
                  return version.versionId === versionId;
                });
                newOutput = _objectSpread({}, currentOutput, {
                  versions: _toConsumableArray(currentOutput.versions)
                });
                updatedVersion = _objectSpread({}, newOutput.versions[versionIndex], {
                  requestedAddons: newRequestedAddons
                });
                newOutput.versions.splice(versionIndex, 1, updatedVersion);
                index = outputs.findIndex(function (_ref11) {
                  var outputId = _ref11.outputId;
                  return outputId === currentOutput.outputId;
                });
                updatedOutputs = _toConsumableArray(outputs);
                updatedOutputs.splice(index, 1, newOutput);

                _this.setState({
                  outputs: updatedOutputs
                });

              case 23:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x) {
        return _ref10.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "onSubmitChanges", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var _ref13,
          purchaseOrderId,
          clientRejectionReasons,
          hasCost,
          _this$props3,
          requestOutputChanges,
          history,
          videoId,
          internalMode,
          prevCurrentOutput,
          prevStatus,
          _yield$requestOutputC,
          data,
          error,
          currentOutput,
          status,
          alertType,
          _args4 = arguments;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _ref13 = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {}, purchaseOrderId = _ref13.purchaseOrderId, clientRejectionReasons = _ref13.clientRejectionReasons, hasCost = _ref13.hasCost;
              _this$props3 = _this.props, requestOutputChanges = _this$props3.requestOutputChanges, history = _this$props3.history, videoId = _this$props3.videoId;
              internalMode = _this.state.internalMode;
              prevCurrentOutput = _this.getCurrentOutput();

              if (prevCurrentOutput) {
                _context4.next = 6;
                break;
              }

              return _context4.abrupt("return");

            case 6:
              prevStatus = prevCurrentOutput.status;
              _context4.next = 9;
              return requestOutputChanges({
                purchaseOrderId: purchaseOrderId,
                clientRejectionReasons: clientRejectionReasons,
                hasCost: hasCost
              });

            case 9:
              _yield$requestOutputC = _context4.sent;
              data = _yield$requestOutputC.data;
              error = _yield$requestOutputC.error;

              if (!(!data || error)) {
                _context4.next = 14;
                break;
              }

              return _context4.abrupt("return");

            case 14:
              _this.setState({
                openedModal: void 0
              });

              if (!internalMode) {
                _context4.next = 18;
                break;
              }

              _this.setState({
                internalMode: false
              });

              return _context4.abrupt("return", void history.replace('/traffic'));

            case 18:
              currentOutput = _this.getCurrentOutput();
              status = data.requestOutputChanges.status;

              if (!(!currentOutput || status.name !== 'EDITING')) {
                _context4.next = 22;
                break;
              }

              return _context4.abrupt("return", void _this.fetchData());

            case 22:
              alertType = prevStatus.name === 'PENDING_REVIEW' ? _successAlerts.SUCCESS_TYPE.REQUEST_CHANGES : _successAlerts.SUCCESS_TYPE.ADMIN_REQUEST_CHANGES;
              history.push("".concat(videoId, "/").concat(currentOutput.outputId, "?success=").concat(alertType, "#").concat(currentOutput.latestVersion + 1));

              _this.fetchData();

            case 25:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));

    _defineProperty(_assertThisInitialized(_this), "handleUpdateAddonStatus", /*#__PURE__*/function () {
      var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref14) {
        var addonType, status, value, rejectionReason, updateAddonStatus, outputs, currentVersion, currentOutput, input, _yield$updateAddonSta, data, error, versionIndex, newOutput, _data$updateAddonStat, dueDate, appliedAddons, updatedVersion, index, updatedOutputs;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                addonType = _ref14.addonType, status = _ref14.status, value = _ref14.value, rejectionReason = _ref14.rejectionReason;
                updateAddonStatus = _this.props.updateAddonStatus;
                outputs = _this.state.outputs;
                currentVersion = _this.getCurrentVersion();
                currentOutput = _this.getCurrentOutput();

                if (!(!currentVersion || !currentOutput)) {
                  _context5.next = 7;
                  break;
                }

                return _context5.abrupt("return");

              case 7:
                input = {
                  addonType: addonType,
                  status: status,
                  value: value,
                  rejectionReason: rejectionReason
                };
                _context5.next = 10;
                return updateAddonStatus({
                  versionId: currentVersion.versionId,
                  input: input
                });

              case 10:
                _yield$updateAddonSta = _context5.sent;
                data = _yield$updateAddonSta.data;
                error = _yield$updateAddonSta.error;

                if (!(!data || error)) {
                  _context5.next = 15;
                  break;
                }

                return _context5.abrupt("return");

              case 15:
                versionIndex = currentOutput.versions.findIndex(function (version) {
                  return version.versionId === currentVersion.versionId;
                });
                newOutput = _objectSpread({}, currentOutput, {
                  versions: _toConsumableArray(currentOutput.versions)
                });
                _data$updateAddonStat = data.updateAddonStatus, dueDate = _data$updateAddonStat.dueDate, appliedAddons = _data$updateAddonStat.appliedAddons;
                updatedVersion = _objectSpread({}, newOutput.versions[versionIndex], {
                  dueDate: dueDate,
                  appliedAddons: appliedAddons
                });
                newOutput.versions.splice(versionIndex, 1, updatedVersion);
                index = outputs.findIndex(function (_ref16) {
                  var outputId = _ref16.outputId;
                  return outputId === currentOutput.outputId;
                });
                updatedOutputs = _toConsumableArray(outputs);
                updatedOutputs.splice(index, 1, newOutput);

                _this.setState({
                  outputs: updatedOutputs
                });

              case 24:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x2) {
        return _ref15.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "fetchData", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var _ref18,
          initial,
          _this$props4,
          getVideo,
          outputId,
          fetchAssets,
          fetchCollaborationData,
          selectedVersion,
          orgPermissions,
          _yield$getVideo,
          data,
          error,
          _data$getVideo,
          outputs,
          videoPermissions,
          organisationId,
          name,
          videoProjectName,
          _this$getCurrentOutpu,
          status,
          _args6 = arguments;

      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _ref18 = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {}, initial = _ref18.initial;
              _this$props4 = _this.props, getVideo = _this$props4.getVideo, outputId = _this$props4.outputId, fetchAssets = _this$props4.fetchAssets, fetchCollaborationData = _this$props4.fetchCollaborationData, selectedVersion = _this$props4.selectedVersion, orgPermissions = _this$props4.orgPermissions;
              _context6.next = 4;
              return getVideo();

            case 4:
              _yield$getVideo = _context6.sent;
              data = _yield$getVideo.data;
              error = _yield$getVideo.error;

              if (!(!data || error || !data.getVideo || !data.getProjectForVideo)) {
                _context6.next = 9;
                break;
              }

              return _context6.abrupt("return", void _this.setState({
                loading: false,
                error: error
              }));

            case 9:
              fetchAssets(data);
              _data$getVideo = data.getVideo, outputs = _data$getVideo.outputs, videoPermissions = _data$getVideo.permissions, organisationId = _data$getVideo.organisationId, name = _data$getVideo.name, videoProjectName = data.getProjectForVideo.name;
              fetchCollaborationData(organisationId);

              if (outputs.length) {
                _context6.next = 14;
                break;
              }

              return _context6.abrupt("return", void _this.setState({
                loading: false,
                outputs: []
              }));

            case 14:
              _context6.next = 16;
              return _this.fetchNextStatus();

            case 16:
              _this.setState({
                loading: false,
                outputs: outputs,
                videoPermissions: videoPermissions,
                videoName: name,
                videoProjectName: videoProjectName,
                organisationId: organisationId
              }, function () {
                if (!outputs.find(function (output) {
                  return output.outputId === outputId;
                })) {
                  return void _this.gotoOutput(outputs[0].outputId, selectedVersion, {
                    replace: true
                  })();
                }

                return void _this.gotoOutput(outputId, selectedVersion, {
                  replace: true
                })();
              });

              _context6.prev = 17;
              _context6.next = 20;
              return _this.fetchAllStatuses(organisationId);

            case 20:
              if (initial) {
                _context6.next = 22;
                break;
              }

              return _context6.abrupt("return");

            case 22:
              _this$getCurrentOutpu = _this.getCurrentOutput(), status = _this$getCurrentOutpu.status.name;

              _this.setState({
                internalMode: (0, _commonReact.hasPermission)('INTERNAL', orgPermissions) && (status === 'INTERNAL_REVIEW' || status === 'EDITING')
              });

              _context6.next = 29;
              break;

            case 26:
              _context6.prev = 26;
              _context6.t0 = _context6["catch"](17);
              return _context6.abrupt("return");

            case 29:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[17, 26]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "fetchNextStatus", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      var getOutputNextStatus, _yield$getOutputNextS, data, error;

      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              getOutputNextStatus = _this.props.getOutputNextStatus;
              _context7.next = 3;
              return getOutputNextStatus();

            case 3:
              _yield$getOutputNextS = _context7.sent;
              data = _yield$getOutputNextS.data;
              error = _yield$getOutputNextS.error;

              if (!(!data || error || !data.getOutputNextStatus)) {
                _context7.next = 8;
                break;
              }

              return _context7.abrupt("return", void _this.setState({
                error: error
              }));

            case 8:
              _this.setState({
                nextStatus: data.getOutputNextStatus
              });

            case 9:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    })));

    _defineProperty(_assertThisInitialized(_this), "fetchAllStatuses", function (organisationId) {
      return new Promise( /*#__PURE__*/function () {
        var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(resolve, reject) {
          var getOutputStatuses, _yield$getOutputStatu, data, error;

          return _regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  getOutputStatuses = _this.props.getOutputStatuses;
                  _context8.next = 3;
                  return getOutputStatuses(organisationId);

                case 3:
                  _yield$getOutputStatu = _context8.sent;
                  data = _yield$getOutputStatu.data;
                  error = _yield$getOutputStatu.error;

                  if (!(!data || error || !data.getOutputStatuses)) {
                    _context8.next = 8;
                    break;
                  }

                  return _context8.abrupt("return", void _this.setState({
                    error: error
                  }, reject));

                case 8:
                  _this.setState({
                    statuses: data.getOutputStatuses
                  }, resolve);

                case 9:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8);
        }));

        return function (_x3, _x4) {
          return _ref20.apply(this, arguments);
        };
      }());
    });

    _defineProperty(_assertThisInitialized(_this), "gotoOutput", function (targetOutputId, versionNumber) {
      var _ref21 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          replace = _ref21.replace;

      return function () {
        var _this$props5 = _this.props,
            history = _this$props5.history,
            videoId = _this$props5.videoId,
            selectedVersion = _this$props5.selectedVersion,
            outputId = _this$props5.outputId;

        var output = _this.getOutput(targetOutputId);

        if (!output) {
          return;
        }

        var versionToGoto = versionNumber || output.latestVersion;

        _this.setState({
          currentVersionNumber: versionToGoto
        });

        if (targetOutputId === outputId && selectedVersion === versionToGoto) {
          return;
        }

        var pushAction = replace ? history.replace : history.rootPush;
        pushAction("".concat(_basePath.default, "/").concat(videoId, "/").concat(targetOutputId).concat(history.location.search, "#").concat(versionToGoto));
      };
    });

    _defineProperty(_assertThisInitialized(_this), "goBackToProjects", function () {
      var history = _this.props.history;
      history.rootPush('/video-tool/');
    });

    _defineProperty(_assertThisInitialized(_this), "getOutput", function (outputId) {
      var outputs = _this.state.outputs;
      return outputs && outputs.find(function (output) {
        return output.outputId === outputId;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getVersion", function (outputId, versionNumber) {
      var output = _this.getOutput(outputId);

      if (!output) return null;

      if (!versionNumber) {
        return (0, _lodash2.default)(output.versions, 'versionNumber');
      }

      return output.versions.find(function (version) {
        return version.versionNumber === versionNumber;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getCurrentOutput", function () {
      var outputId = _this.props.outputId;
      return _this.getOutput(outputId);
    });

    _defineProperty(_assertThisInitialized(_this), "getCurrentVersion", function () {
      var currentVersionNumber = _this.state.currentVersionNumber;
      var outputId = _this.props.outputId;
      return _this.getVersion(outputId, currentVersionNumber);
    });

    _defineProperty(_assertThisInitialized(_this), "getMasterOutput", function (outputs, videoName) {
      var videoId = _this.props.videoId;
      var masterOutput = outputs.find(function (output) {
        return output.isMaster;
      });
      return {
        name: (0, _getVideoOutputName.default)(masterOutput, videoName),
        outputId: masterOutput.outputId,
        videoId: videoId
      };
    });

    _this.state = {
      outputs: [],
      loading: true,
      videoPermissions: [],
      internalMode: false,
      nextStatus: void 0,
      openedModal: void 0,
      requestChanges: Object.keys(_queryString.default.parse(props.history.location.search)).includes('requestChanges')
    };
    return _this;
  }

  _createClass(VideoReviewRoot, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var history = this.props.history;
      this.fetchData({
        initial: true
      });
      window.addEventListener('keydown', this.handleKeyDown);

      var _queryString$parse = _queryString.default.parse(history.location.search),
          success = _queryString$parse.success;

      if (!success || typeof success !== 'string') {
        return;
      }

      this.showAlert(success);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref22) {
      var prevHistory = _ref22.history;
      var history = this.props.history;

      if (!history.location.search) {
        return;
      }

      var _queryString$parse2 = _queryString.default.parse(history.location.search),
          successType = _queryString$parse2.success;

      var _queryString$parse3 = _queryString.default.parse(prevHistory.location.search),
          prevSuccessType = _queryString$parse3.success;

      if (!successType || typeof successType !== 'string' || !_successAlerts.default[successType] || prevSuccessType === successType) {
        return;
      }

      this.showAlert(successType);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          outputs = _this$state.outputs,
          error = _this$state.error,
          loading = _this$state.loading,
          _this$state$currentVe = _this$state.currentVersionNumber,
          currentVersionNumber = _this$state$currentVe === void 0 ? 1 : _this$state$currentVe,
          internalMode = _this$state.internalMode,
          videoPermissions = _this$state.videoPermissions,
          nextStatus = _this$state.nextStatus,
          _this$state$statuses = _this$state.statuses,
          statuses = _this$state$statuses === void 0 ? [] : _this$state$statuses,
          openedModal = _this$state.openedModal,
          videoName = _this$state.videoName,
          videoProjectName = _this$state.videoProjectName,
          organisationId = _this$state.organisationId,
          approvedStatus = _this$state.approvedStatus,
          requestChanges = _this$state.requestChanges;
      var _this$props6 = this.props,
          videoId = _this$props6.videoId,
          outputId = _this$props6.outputId,
          history = _this$props6.history,
          orgPermissions = _this$props6.orgPermissions;

      if (error) {
        return /*#__PURE__*/_react.default.createElement(_commonReact.Error, null);
      }

      if (loading) {
        return /*#__PURE__*/_react.default.createElement(_uiKit.Loader, null);
      }

      var currentOutput = this.getCurrentOutput();
      var currentVersion = this.getCurrentVersion();

      if (!outputs.length || !currentOutput || !currentVersion || currentOutput.status.name === 'DRAFT') {
        return /*#__PURE__*/_react.default.createElement(_commonReact.NotFound, null);
      }

      var isLatestVersion = currentVersion.versionNumber === currentOutput.latestVersion;
      var hasApprovePermission = (0, _commonReact.hasPermission)('APPROVE', videoPermissions);
      var hasCommentPermission = currentOutput.status.name === 'APPROVED' ? false : (0, _commonReact.hasPermission)('COMMENT', videoPermissions);
      var hasUpdatePermission = (0, _commonReact.hasPermission)('UPDATE', videoPermissions) && isLatestVersion;
      var hasInternalPermission = (0, _commonReact.hasPermission)('INTERNAL', orgPermissions);
      var isMaster = currentOutput.isMaster;
      var status = approvedStatus || currentOutput.status;
      var assetId = currentVersion.assetId,
          versionId = currentVersion.versionId,
          versionNumber = currentVersion.versionNumber;
      var isVideoReady = this.isVideoReady({
        assetId: assetId,
        status: status
      });
      var onApproveVersion = nextStatus === 'APPROVED' ? this.openModal(_modalNames.default.APPROVE) : this.onApproveVersion;

      var _buildSmartProgressDa = (0, _buildSmartProgressData.default)((0, _buildOrgStatuses.default)(statuses), status.name, internalMode),
          smartStatuses = _buildSmartProgressDa.statuses,
          smartIndex = _buildSmartProgressDa.index;

      return /*#__PURE__*/_react.default.createElement(_VideoReviewContext.default.Provider, {
        value: (0, _videoReviewContext.default)({
          state: {
            outputs: outputs,
            videoId: videoId,
            videoPermissions: videoPermissions,
            hasApprovePermission: hasApprovePermission,
            hasCommentPermission: hasCommentPermission,
            hasUpdatePermission: hasUpdatePermission,
            selectedOutputId: outputId,
            currentVersionNumber: currentVersionNumber,
            internalMode: internalMode,
            isVideoReady: isVideoReady,
            videoName: videoName,
            nextStatus: nextStatus,
            videoProjectName: videoProjectName
          },
          actions: {
            onApproveVersion: onApproveVersion,
            onRequestChanges: this.openModal(_modalNames.default.PAYMENT),
            onRequestChangesForApproved: this.openModal(_modalNames.default.APPROVED),
            onRequestApproval: this.onRequestApproval,
            getCurrentOutput: this.getCurrentOutput,
            getCurrentVersion: this.getCurrentVersion,
            gotoOutput: this.gotoOutput,
            onUpdateRequestedAddons: this.onUpdateRequestedAddons,
            toggleInternalMode: this.toggleInternalMode,
            updateAddonStatus: this.handleUpdateAddonStatus
          }
        })
      }, /*#__PURE__*/_react.default.createElement(_commonReact.CommentsProvider, {
        resourceId: versionId,
        resourceOrganisationId: organisationId,
        modalTarget: ".video-review-root__content",
        filterByMetadataFlag: {
          key: 'internalMode',
          value: internalMode
        },
        canResolveComment: internalMode
      }, /*#__PURE__*/_react.default.createElement(_ModalSwitcher.default, {
        openedModal: openedModal,
        onClose: this.closeModal,
        onApproveVersion: this.onApproveVersion,
        onRequestChanges: this.onSubmitChanges,
        outputStatus: status,
        output: this.getCurrentOutput(),
        videoName: videoName
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "video-review-root page--no-padding"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('video-review-root__content', {
          'video-review-root__content--internal': internalMode
        })
      }, /*#__PURE__*/_react.default.createElement("button", {
        onClick: (0, _commonReact.hasPermission)('INTERNAL', orgPermissions) ? this.toggleInternalMode : void 0,
        className: "video-review-root__content__exit-internal",
        type: "button"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
        name: "close",
        size: 8,
        color: "white"
      }), "Exit Internal Mode"), /*#__PURE__*/_react.default.createElement(_Header.default, {
        history: history,
        hasInternalPermission: hasInternalPermission,
        gotoOutput: this.gotoOutput,
        internalMode: internalMode,
        toggleInternalMode: this.toggleInternalMode
      }), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: 'flex',
          width: '100%',
          flex: 1
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: 'flex',
          flex: 1
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "video-review-root__content__row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "video-review-root__content__row__left"
      }, /*#__PURE__*/_react.default.createElement(_ProgressBar.default, {
        statuses: (0, _formatStatuses.default)(smartStatuses),
        currentStatus: smartIndex
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "video-review-root__content__inner column"
      }, /*#__PURE__*/_react.default.createElement(_VideoOutput.default, {
        currentVersion: currentVersion,
        masterOutput: !isMaster && currentOutput.status.name === 'PENDING_MASTER' ? this.getMasterOutput(outputs, videoName) : void 0,
        currentOutput: currentOutput,
        assetId: assetId,
        hasCommentPermission: hasCommentPermission,
        isVideoReady: isVideoReady,
        isLatestVersion: isLatestVersion
      })), /*#__PURE__*/_react.default.createElement(_Footer.default, {
        assetId: assetId,
        outputStatus: status,
        versionNumber: versionNumber,
        isVideoReady: isVideoReady,
        isLatestVersion: isLatestVersion,
        currentVersion: currentVersion,
        videoPermissions: videoPermissions,
        nextStatus: nextStatus,
        requestChanges: requestChanges,
        goBackToProjects: this.goBackToProjects,
        hasInternalPermission: hasInternalPermission
      })))), /*#__PURE__*/_react.default.createElement(_Drawer.default, {
        gotoOutput: this.gotoOutput,
        internalMode: internalMode,
        videoName: videoName
      }))))));
    }
  }]);

  return VideoReviewRoot;
}(_react.Component);

var _default = VideoReviewRoot;
exports.default = _default;